import '../../../form/elements/select.css';

import React, { useCallback, useEffect, useState, useRef } from 'react';
import ReactSelect from 'react-select';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { route } from '../../../../services/utils';
import { useDispatch } from 'react-redux';
import { season } from '../../../../store/global-slice';
import { useService } from '../../../../services/services';
import css from './season-switcher.module.css';
import Season from '../../../../interfaces/season';
import { FieldHistoryTabs } from '../../../../enums/field-history-tabs';
import {
  CROP_FIELD_HISTORY_VIEW,
  FINANCE_BUDGET_INDEX,
  REPORTING_VAAD_LIZ_REPORTS,
  REPORTING_VAAD_LIZ_REPORTS_CREATE,
  REPORTING_VAAD_LIZ_REPORTS_UPDATE,
  REPORTING_VAAD_LIZ_REPORTS_VIEW,
} from '../../../../router/routes';
import { UrlParameters } from '../../../../enums/url-parameters';
interface Option {
  value: number;
  label: string;
}

const theme = {
  borderRadius: 0,
  colors: {
    primary: '',
    primary75: '',
    primary50: '',
    primary25: '',
    danger: '',
    dangerLight: '',
    neutral0: '',
    neutral5: '',
    neutral10: '',
    neutral20: '',
    neutral30: '',
    neutral40: '',
    neutral50: '',
    neutral60: '',
    neutral70: '',
    neutral80: '',
    neutral90: '',
  },
  spacing: { baseUnit: 0, controlHeight: 0, menuGutter: 0 },
};

export default function SeasonSwitcher({ show = false }: { show?: boolean }) {
  const { t } = useTranslation();
  const history = useHistory();
  const params: any & { farmId: string; season: number } = useParams();
  const currentRoute = useRouteMatch();
  const dispatch = useDispatch();
  const isMounted = useRef(true);
  const [options, setOptions] = useState<Option[]>([]);
  const { farmService } = useService();

  useEffect(() => {
    isMounted.current = true;
    if (params.farmId && params.farmId !== UrlParameters.FARM_ID) {
      farmService
        .seasons(params.farmId)
        .subscribe((seasons: { [key: string]: any }) => {
          if (Array.isArray(seasons)) {
            if (isMounted.current) {
              setOptions(
                seasons.map((season: Season): Option => {
                  return {
                    value: season.id,
                    label: season.title,
                  };
                })
              );
            }
          }
        });
    }
    return () => {
      isMounted.current = false;
    };
  }, [params.farmId, params.season, farmService]);

  const onChange = useCallback(
    (option: Option) => {
      params.season = option.value;

      dispatch(season(option.value.toString()));

      history.push(route(currentRoute.path + history.location.search, params));
    },
    [params, currentRoute.path, dispatch, history]
  );

  if (
    (currentRoute.path === CROP_FIELD_HISTORY_VIEW &&
      currentRoute.url.includes(`/${FieldHistoryTabs.DATA}`)) ||
    (currentRoute.path === REPORTING_VAAD_LIZ_REPORTS && !show) ||
    (currentRoute.path === REPORTING_VAAD_LIZ_REPORTS_UPDATE && !show) ||
    (currentRoute.path === REPORTING_VAAD_LIZ_REPORTS_CREATE && !show) ||
    (currentRoute.path === REPORTING_VAAD_LIZ_REPORTS_VIEW && !show) ||
    (!currentRoute.path.startsWith(
      '/farms/' + UrlParameters.FARM_ID + '/crop'
    ) &&
      currentRoute.path !== FINANCE_BUDGET_INDEX) ||
    options.length === 0
  ) {
    return <></>;
  }

  if (
    'id' in currentRoute.params ||
    'yield_id' in currentRoute.params ||
    currentRoute.path.includes('/create') ||
    currentRoute.path.includes('/edit') ||
    currentRoute.path.endsWith('/merge')
  ) {
    return (
      <div className={css['season-switcher']}>
        <span className={css['read-only']}>
          {
            options.find(
              (option) => option.value.toString() === params.season.toString()
            ).label
          }
        </span>
      </div>
    );
  } else {
    return (
      <form className={css['season-switcher']}>
        <ReactSelect
          name={'season'}
          options={options}
          classNamePrefix="rs"
          placeholder=""
          loadingMessage={t('Loading')}
          noOptionsMessage={t('No options')}
          theme={theme}
          // menuIsOpen={true}
          value={options.find(
            (option) => option.value.toString() === params.season.toString()
          )}
          onChange={onChange}
        />
      </form>
    );
  }
}
